<template>
  <div class="repetitor-banner__wrapper">
    <div class="repetitor-banner">
      <div class="v2-container-small">
        <h3>Репетиторы с 1 по 11 класс</h3>
        <h2>быстрый и&nbsp;удобный <span>подбор репетиторов</span></h2>
        <div class="repetitor-banner__actions">
          <button
            class="m-btn repetitor-banner__podbor"
            @click="scrollTo('.repetitor-catalog')"
          >
            Начать подбор
          </button>
          <button
            class="m-btn repetitor-banner__help"
            @click="$emit('open-consult-modal')"
          >
            Помочь с выбором
          </button>
        </div>

        <button
          class="m-btn repetitor-banner__to-down no-tablet"
          @click="scrollTo('.repetitor-catalog')"
        >
          <img
            src="/v2/catalog/repetitor/banner/arrow-down.svg"
            alt="down"
          >
        </button>
      </div>

      <img
        src="/v2/catalog/repetitor/banner/image.webp"
        alt="image"
        class="repetitor-banner__image no-tablet"
      >
      <img
        src="/v2/catalog/repetitor/banner/image-mob.webp"
        alt="image"
        class="repetitor-banner__image tablet"
      >
    </div>
  </div>
</template>

<script>
import scrollTo from '~/utils/scrollTo';

export default {
  name: 'RepetitorBanner',
  methods: {
    scrollTo,
  },
};
</script>

<style scoped lang="scss">

.repetitor-banner__wrapper {
  width: 100%;
  overflow: hidden;
  padding-bottom: 40px;
  margin-bottom: -40px;
}

.repetitor-banner {
  width: calc(100vw - 120px);
  max-width: 1800px;
  margin-inline: auto;
  filter: drop-shadow(4px 4px 20px rgba($ege-blue-darkest, 0.05));
  border-radius: 60px;
  position: relative;

  background-image: url("/v2/catalog/repetitor/banner/bg.webp");
  background-size: cover;

  @media (max-width: 1480px) {
    width: 100%;
    max-width: 1360px;
  }

  @include media-down(tablet) {
    border-radius: 24px;
    background-image: url("/v2/catalog/repetitor/banner/bg-mob.webp");
    overflow: hidden;
  }

  .v2-container-small {
    position: relative;
    z-index: 2;
    padding-top: 80px;
    padding-bottom: 120px;

    @include media-down(tablet) {
      padding-top: 34px;
      padding-bottom: 34px;
    }
  }

  h3 {
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 18px;
    line-height: 130%;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $blue-dark;

    @include media-down(tablet) {
      margin-bottom: 8px;
      text-align: center;
      font-size: 16px;
      line-height: 100%;
    }
  }

  h2 {
    max-width: 735px;
    margin-bottom: 78px;
    position: relative;

    font-weight: 700;
    font-size: 65px;
    line-height: 100%;
    letter-spacing: -0.02em;
    text-transform: uppercase;
    font-feature-settings: 'case' on;
    color: $black;

    @include media-down(desktop) {
      max-width: 620px;
      font-size: 55px;
    }

    @include media-down(laptop) {
      max-width: 455px;
      font-size: 40px;
    }

    @include media-down(tablet) {
      max-width: 310px;
      margin-inline: auto;
      margin-bottom: 32px;

      font-size: 30px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.03em;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      width: calc(100% + 3px);
      height: 60px;
      left: -11px;
      bottom: 3px;

      background-color: $blue-dark;
      box-shadow: 0 2px 35px rgba(0, 62, 135, 0.2);

      @include media-down(desktop) {
        height: 52px;
      }

      @include media-down(laptop) {
        height: 37px;
      }

      @include media-down(tablet) {
        width: 208px;
        height: 32px;
        left: 51px;
        bottom: 1px;
      }
    }

    &:after {
      @include media-down(tablet) {
        content: '';
        display: block;
        position: absolute;
        background-color: $blue-dark;
        box-shadow: 0 2px 35px rgba(0, 62, 135, 0.2);

        width: 128px;
        height: 32px;
        right: 0;
        bottom: 34px;
      }
    }

    span {
      position: relative;
      z-index: 2;
      color: $white-color;
    }
  }

  &__actions {
    display: flex;
    gap: 10px;

    @include media-down(laptop) {
      flex-direction: column;
      gap: 16px;
    }

    @include media-down(tablet) {
      align-items: center;
    }

    button {
      padding: 17px 23px 23px;
      border-radius: 500px;

      font-size: 30px;
      line-height: 100%;

      @include media-down(laptop) {
        padding-top: 16px;
        padding-bottom: 20px;
        width: 292px;
        font-size: 24px;
      }

      &.repetitor-banner__podbor {
        background-color: $ege-orange;
        border: 2px solid $brown-dark;

        font-weight: 700;
        color: $white-color;
      }

      &.repetitor-banner__help {
        background-color: $white-color;
        border: 2px solid $ege-blue-middle;

        font-weight: 500;
        color: $black;
      }
    }
  }

  &__to-down {
    width: 64px;
    height: 64px;

    position: absolute;
    z-index: 2;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 50%);

    background-color: $white-color;
    border: 1px solid rgba($black, 0.2);
    border-radius: 50%;

    img {
      opacity: 0.5;
    }

    &:hover img {
      opacity: 1;
    }
  }

  &__image {
    width: 785px;
    position: absolute;
    right: 0;
    bottom: 0;

    @include media-down(desktop) {
      width: 600px;
      right: -50px;
    }

    @include media-down(tablet) {
      position: relative;
      left: 52%;
      bottom: -7px;
      transform: translateX(-50%);
      width: auto;
      height: 343px;
    }
  }
}

</style>
